import React from "react";
import Container from "@/components/marketing/Container";
import { ShieldCheck } from "lucide-react";
import Reveal from "@/components/marketing/Reveal";

export default function GuaranteeBand() {
  return (
    <section className="py-9 sm:py-12 lg:py-14">
      <Container className="text-center">
        <Reveal>
          <div className="glass-card inline-block px-8 py-10 lg:px-12 lg:py-12" style={{ borderRadius: 28, maxWidth: 640 }}>
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[rgba(139,92,246,0.1)] mb-5">
            <ShieldCheck className="w-7 h-7 text-[#7c3aed]" strokeWidth={1.75} />
          </div>
          <h2 className="font-heading text-[clamp(28px,3.5vw,42px)] font-[650] tracking-[-0.02em] leading-[1.1] mb-3.5 text-heading-gradient">
            Published, or your money back
          </h2>
          <p className="text-[15px] lg:text-[16px] text-[#55555c] max-w-[440px] mx-auto leading-relaxed mb-2.5">
            Every guaranteed placement is exactly that. If we cannot get your article published on the outlet you chose, you get a full refund.
          </p>
          <p className="text-[13px] font-medium text-[#8e8e96]">
            No fine print, no vague promises.
          </p>
          </div>
        </Reveal>
      </Container>
    </section>
  );
}